// extracted by mini-css-extract-plugin
export default {"card":"CurrencyHashrateChart_card__BGqrr"};